/**
 * The mini-games' sounds, by moment: aliases of the road's audio
 * (assets/audio/road, loaded with the road), levelled like the Lamp Run's.
 * The coin burst and the fanfare are the run's own.
 */
export const GAME_SOUNDS = {
  /** Paper and ribbon, then a sparkle: a parcel opens. */
  parcelOpen: 'road:parcel_open',
  /** Coins land: an ordinary prize. */
  coins: 'road:coin_burst',
  /** The fanfare: a game's top prize. */
  topPrize: 'road:run_fanfare',
  /** A mallet bonks a toadstool and it cracks open. */
  smash: 'road:smash_crack',
  /** A card turns over. */
  flip: 'road:hilo_flip',
  /** Two bells: a pair found. */
  pair: 'road:pair_chime',
  /** A coin scratches the foil. */
  scratch: 'road:scratch',
  /** The wheel's pegs passing the pointer, and its stop (the slot's own). */
  wheelTick: 'wheel:tick',
  wheelLand: 'wheel:land',
  /** A cup slides across the table: each swap. */
  cupSlide: 'road:cup_slide',
  /** A spade scoops into soil: each dig. */
  dig: 'road:dig_shovel',
  /** A bomb goes off (the Lamp Run's own). */
  bomb: 'road:bomb_pop',
  /** A mole pops up out of its hole. */
  molePop: 'road:whack_pop',
  /** A mallet bonks a mole. */
  bonk: 'road:whack_bonk',
  /** The whistle: the round is over. */
  whistle: 'road:whack_whistle',
  /** The countdown's 3, 2, 1 (the run's chase tick), then GO and a prize
   *  stepping up (the Hi-Lo rung). */
  countdown: 'road:chase_tick',
  go: 'road:hilo_rung_up',
  prizeUp: 'road:hilo_rung_up',
  /** The pace steps up: "Faster!" */
  faster: 'road:sweep_whoosh',
} as const;

/** What a game's prize sounds like, after its reveal sound. */
export const prizeSound = (coins: number, top: number): string => (coins >= top ? GAME_SOUNDS.topPrize : GAME_SOUNDS.coins);
